import { render, staticRenderFns } from "./ForceReset.vue?vue&type=template&id=8ac90b52&scoped=true&"
import script from "./ForceReset.vue?vue&type=script&lang=js&"
export * from "./ForceReset.vue?vue&type=script&lang=js&"
import style0 from "./ForceReset.vue?vue&type=style&index=0&id=8ac90b52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac90b52",
  null
  
)

export default component.exports